import React from "react";
import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Paper,
  Typography,
} from "@mui/material";
import resetPasswordStyles from "./ResetPasswordStyles.module.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsLoading } from "../../features/userSlice";
import styles from "./ResetPasswordStyles.module.css";
import { Stack } from "@mui/system";

interface ResetPasswordUIProps {
  email: string;
  onEmailChange: (value: string) => void;
  onResetPasswordClick: () => void;
  showSuccessPopup: boolean;
  showErrorPopup: boolean;
  onCloseSuccessPopup: () => void;
  onCloseErrorPopup: () => void;
  errorPopupMessage: string;
}

const ResetPasswordSection: React.FC<ResetPasswordUIProps> = ({
  email,
  onEmailChange,
  onResetPasswordClick,
  showSuccessPopup,
  showErrorPopup,
  onCloseSuccessPopup,
  onCloseErrorPopup,
  errorPopupMessage,
}) => {
  const loading = useSelector(selectIsLoading);
  return (
    <Stack alignItems="center" flexDirection={"row"}>
      <img
        className={styles.backgroundImage1}
        alt="Background"
        src="/background-image-1@2x.png"
      />
      <Stack
        alignItems="center"
        justifyContent={"space-around"}
        sx={{ flex: 1 }}
      >
        <Paper
          sx={{
            p: 4,
            textAlign: "center",
            width: "100%",
            maxWidth: 360,
            borderRadius: 2,
            boxShadow: `
            0px 6px 6px -3px rgba(0, 0, 0, 0.2),
            0px 10px 14px 1px rgba(0, 0, 0, 0.14),
            0px 4px 18px 3px rgba(0, 0, 0, 0.12)
          `,
          }}
        >
          <div className={resetPasswordStyles.resetPasswordLogoSection}>
            <img
              className={resetPasswordStyles.optivalLogo1Icon}
              alt=""
              src="/optivallogo-1@2x.png"
            />
          </div>
          <div className={resetPasswordStyles.resetPasswordTitleSection}>
            <h4 className={resetPasswordStyles.typography1}>
              <Typography variant="h6">
                Confirm Your E-mail to Reset Password
              </Typography>
            </h4>
          </div>
          <form className={resetPasswordStyles.resetPasswordActionsSection}>
            <div className={resetPasswordStyles.resetPasswordTextFieldsSection}>
              <TextField
                className={resetPasswordStyles.textfield}
                color="secondary"
                variant="outlined"
                type="text"
                label="Email"
                placeholder="Enter Your Email"
                size="medium"
                margin="none"
                required
                value={email}
                onChange={(e) => onEmailChange(e.target.value)}
              />
            </div>

            <Button
              className={resetPasswordStyles.resetPasswordButton}
              variant="contained"
              color="secondary"
              onClick={onResetPasswordClick}
              loading={loading}
            >
              Reset Password
            </Button>
            <Link to="/login" className={resetPasswordStyles.backToLoginButton}>
              <Button variant="text" color="secondary">
                Back to Login
              </Button>
            </Link>
          </form>
        </Paper>
      </Stack>

      <Snackbar
        open={showSuccessPopup}
        autoHideDuration={6000}
        onClose={onCloseSuccessPopup}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={onCloseSuccessPopup}
          severity="success"
          action={
            <Button color="inherit" size="small" onClick={onCloseSuccessPopup}>
              CLOSE
            </Button>
          }
        >
          Password reset email sent successfully!
        </Alert>
      </Snackbar>

      <Snackbar
        open={showErrorPopup}
        autoHideDuration={6000}
        onClose={onCloseErrorPopup}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={onCloseErrorPopup}
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={onCloseErrorPopup}>
              CLOSE
            </Button>
          }
        >
          {errorPopupMessage}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default ResetPasswordSection;
